/**
 * Componente: SpecialtyFilter
 * Filtra médicos por especialidade
 */

interface SpecialtyFilterProps {
  selectedSpecialty: string | null;
  onSpecialtyChange: (specialty: string | null) => void;
  availableSpecialties?: string[];
}

const DEFAULT_SPECIALTIES = [
  'Todas as Especialidades',
  'Cardiologia',
  'Pediatria',
  'Neurologia',
  'Dermatologia',
  'Ortopedia',
  'Psiquiatria',
  'Clínica Geral',
];

export function SpecialtyFilter({
  selectedSpecialty,
  onSpecialtyChange,
  availableSpecialties = DEFAULT_SPECIALTIES,
}: SpecialtyFilterProps) {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {availableSpecialties.map((specialty) => (
        <button
          key={specialty}
          onClick={() =>
            onSpecialtyChange(
              specialty === 'Todas as Especialidades' ? null : specialty
            )
          }
          className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
            (specialty === 'Todas as Especialidades' && !selectedSpecialty) ||
            selectedSpecialty === specialty
              ? 'bg-teal-600 text-white dark:bg-teal-500'
              : 'bg-gray-100 dark:bg-neutral-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-neutral-700'
          }`}
        >
          {specialty}
        </button>
      ))}
    </div>
  );
}
